import React from 'react'
import { SvgIcon } from 'material-ui'

const ContactIcon = props => (
  <SvgIcon x="0px" y="0px" viewBox="0 0 283.5 283.5" {...props}>
    <g display="none">
      <path
        display="inline"
        d="M265.6,6.5H17.8c-6.3,0-11.3,5.1-11.3,11.3v247.8c0,6.3,5.1,11.3,11.3,11.3h247.8
		c6.3,0,11.3-5.1,11.3-11.3V17.8C277,11.6,271.9,6.5,265.6,6.5z M254.3,254.3H29.2V29.2h225.1V254.3z"
      />
      <path
        display="inline"
        d="M176.9,117.2h43.9c6.3,0,11.3-5.1,11.3-11.3c0-6.3-5.1-11.3-11.3-11.3h-43.9
		c-6.3,0-11.3,5.1-11.3,11.3C165.5,112.1,170.6,117.2,176.9,117.2z"
      />
      <path
        display="inline"
        d="M176.9,200.4h43.9c6.3,0,11.3-5.1,11.3-11.3c0-6.3-5.1-11.3-11.3-11.3h-43.9
		c-6.3,0-11.3,5.1-11.3,11.3C165.5,195.3,170.6,200.4,176.9,200.4z"
      />
      <path
        display="inline"
        d="M59.5,200.4c1,0,1.9-0.1,2.8-0.4c0.9,0.2,1.9,0.4,2.8,0.4h28.4v7.6
		c0,6.3,5.1,11.3,11.3,11.3h37.8c6.3,0,11.3-5.1,11.3-11.3v-37.8c0-6.3-5.1-11.3-11.3-11.3h-37.8c-6.3,0-11.3,5.1-11.3,11.3v7.6
		H70.8v-60.5h22.7v7.6c0,6.3,5.1,11.3,11.3,11.3h37.8c6.3,0,11.3-5.1,11.3-11.3V86.9c0-6.3-5.1-11.3-11.3-11.3h-37.8
		c-6.3,0-11.3,5.1-11.3,11.3v7.6H70.8V57.9c0-6.3-5.1-11.3-11.3-11.3c-6.3,0-11.3,5.1-11.3,11.3V189
		C48.1,195.3,53.2,200.4,59.5,200.4z M116.2,181.5h15.1v15.1h-15.1V181.5z M116.2,98.3h15.1v15.1h-15.1V98.3z"
      />
    </g>
    <g display="none">
      <path
        display="inline"
        d="M265,9H18.4C12,9,6.8,14.1,6.8,20.6v175.6c0,6.4,5.2,11.6,11.6,11.6h106.3l-46.6,46.9
		c-4.5,4.5-4.5,11.9,0,16.4c4.6,4.5,11.9,4.5,16.4,0l35.5-35.8v10.2c0,6.4,5.2,11.6,11.6,11.6c6.4,0,11.6-5.2,11.6-11.6v-10.2
		l35.5,35.8c2.3,2.3,5.2,3.4,8.2,3.4c3,0,5.9-1.1,8.2-3.4c4.5-4.5,4.6-11.9,0-16.4l-46.6-46.9H265c6.4,0,11.6-5.2,11.6-11.6V20.6
		C276.6,14.1,271.4,9,265,9z M253.4,32.2v18.4H30V32.2H253.4z M30,184.6V62.1h223.4v122.4H30z"
      />
      <path
        display="inline"
        d="M78.4,114.3c-6.4,0-11.6,5.2-11.6,11.6v34.8c0,6.4,5.2,11.6,11.6,11.6
		c6.4,0,11.6-5.2,11.6-11.6V126C90,119.5,84.8,114.3,78.4,114.3z"
      />
      <path
        display="inline"
        d="M120.6,76.6c-6.4,0-11.6,5.2-11.6,11.6v72.5c0,6.4,5.2,11.6,11.6,11.6s11.6-5.2,11.6-11.6
		V88.2C132.2,81.8,127,76.6,120.6,76.6z"
      />
      <path
        display="inline"
        d="M162.9,126c-6.4,0-11.6,5.2-11.6,11.6v23.2c0,6.4,5.2,11.6,11.6,11.6
		c6.4,0,11.6-5.2,11.6-11.6v-23.2C174.5,131.1,169.3,126,162.9,126z"
      />
      <path
        display="inline"
        d="M205.1,91.1c-6.4,0-11.6,5.2-11.6,11.6v58c0,6.4,5.2,11.6,11.6,11.6s11.6-5.2,11.6-11.6
		v-58C216.7,96.3,211.5,91.1,205.1,91.1z"
      />
    </g>
    <path
      display="none"
      d="M246.7,227.1C246.7,227.1,246.7,227.1,246.7,227.1c43.2-53.1,40.1-131.5-9.3-181
	c-25.6-25.5-59.5-39.6-95.7-39.6c-36.1,0-70.1,14.1-95.6,39.6C20.6,71.6,6.5,105.6,6.5,141.7c0,36.1,14.1,70.1,39.6,95.7
	c25.6,25.5,59.5,39.6,95.6,39.6c36.1,0,70.1-14.1,95.7-39.6c2.9-2.9,5.6-5.9,8.2-9C246,227.9,246.3,227.5,246.7,227.1
	C246.7,227.1,246.7,227.1,246.7,227.1z M62.4,62.3c21.2-21.2,49.4-32.9,79.4-32.9c30,0,58.2,11.7,79.4,32.9
	c37.9,37.9,43,96.5,15.2,139.9c-0.4-0.2-0.8-0.5-1.2-0.7c-17.5-8.3-36.1-14.2-55.5-17.6c5.3-4.8,8.6-10.7,9.1-16.3l0.6-4.8
	c4.6-2.4,7.9-6.9,8.4-12.4l2.3-22.4c0.6-5.2-1.5-10.1-5.2-13.3l0.6-5.9c0.7-7.8,2.5-26.1-11.6-38.6c-9.9-9.7-25.3-15.2-42.2-15.2
	c-17,0-32.3,5.6-41.8,14.9c-14.4,12.9-12.7,31.2-11.9,39l0.6,5.7c-3.6,3.3-5.7,8.2-5.2,13.3l2.3,22.4c0.6,5.5,3.8,10,8.4,12.3
	c0.2,1.5,0.3,3.1,0.5,4.6c0.6,5.9,3.9,11.8,9.2,16.5c-19.4,3.4-38.1,9.3-55.9,17.8c-0.3,0.1-0.5,0.3-0.8,0.5
	c-11.5-17.9-17.6-38.7-17.6-60.5C29.5,111.7,41.2,83.5,62.4,62.3z M141.7,254c-2.8,0-5.6-0.1-8.4-0.3c-21.3-1.6-41.4-9-58.4-21.7
	c-4.4-3.3-8.6-6.9-12.6-10.9c-0.2-0.2-0.3-0.3-0.5-0.5c0,0,0,0,0,0c17.7-8,36.8-13.2,56.6-15.6c3.1-0.4,5.9-2,7.8-4.4
	c1.9-2.5,2.7-5.6,2.2-8.6l-2.2-15.6c-0.5-3.3-2.4-6.3-5.2-8.1c-2.2-1.4-3.4-3.1-3.5-3.1c-0.5-4.9-1.1-9.8-1.7-14.7
	c-0.5-4.4-3.6-8.2-7.8-9.5c-0.1,0-0.1,0-0.2-0.1l-0.8-8.1c0.2-0.1,0.3-0.2,0.5-0.3c3.6-2.4,5.5-6.6,5-10.8l-1.6-14.6
	c-0.7-7.4-1-15,4.8-20.1c5.5-5.4,15.3-8.7,26.1-8.7c10.8,0,20.6,3.2,26.5,9c5.3,4.7,5.1,12.3,4.4,19.7l-1.7,14.6
	c-0.5,4.3,1.4,8.4,4.9,10.8c0.2,0.1,0.4,0.3,0.6,0.4l-0.9,8.1c0,0-0.1,0-0.2,0.1c-4.2,1.4-7.3,5.1-7.8,9.5l-1.6,14.3
	c-0.2,0.5-1.4,2.2-3.6,3.6c-2.8,1.8-4.6,4.7-5.1,8L155,192c-0.4,3.1,0.4,6.2,2.3,8.6c1.9,2.4,4.7,4,7.7,4.4
	c20,2.4,39.1,7.7,56.6,15.6c-0.2,0.2-0.3,0.3-0.5,0.5C199.9,242.3,171.7,254,141.7,254z"
    />
    <path
      display="none"
      d="M256,12H114c-12,0-21.9,9.8-21.9,21.9v57.4H27.4c-12.1,0-21.9,9.8-21.9,21.9v95.5
	c0,12,9.8,21.9,21.9,21.9h10.2v30.1c0,4.2,2.4,8,6.2,9.8c1.5,0.7,3.1,1.1,4.8,1.1c2.4,0,4.8-0.8,6.8-2.4l48.9-38.6h65.2
	c12,0,21.9-9.8,21.9-21.9v-47.8l36.7,29c2,1.6,4.4,2.4,6.8,2.4c1.6,0,3.2-0.4,4.8-1.1c3.8-1.8,6.2-5.6,6.2-9.8v-30.1H256
	c12.1,0,21.9-9.8,21.9-21.9V33.9C277.9,21.8,268.1,12,256,12z M169.5,208.6h-69c-2.5,0-4.8,0.8-6.8,2.4l-34.1,27v-18.4
	c0-6-4.9-10.9-10.9-10.9H27.4v-95.5h142.1V208.6z M256,129.4h-21.2c-6,0-10.9,4.9-10.9,10.9v18.4L191.4,133v-19.9
	c0-12-9.8-21.9-21.9-21.9H114V33.9H256V129.4z"
    />
    <g>
      <path d="M141.7,6C66.9,6,6,66.9,6,141.7c0,74.8,60.9,135.7,135.7,135.7c74.8,0,135.7-60.9,135.7-135.7
		C277.5,66.9,216.6,6,141.7,6z M141.7,254.6c-62.2,0-112.9-50.6-112.9-112.9c0-62.2,50.6-112.9,112.9-112.9
		c62.2,0,112.9,50.6,112.9,112.9C254.6,204,204,254.6,141.7,254.6z" />
      <path d="M192.2,80.1l-75.1,32.7c-0.3,0.1-0.5,0.3-0.8,0.4c-0.2,0.1-0.4,0.2-0.5,0.3c-0.9,0.6-1.7,1.4-2.3,2.3
		c-0.1,0.2-0.2,0.4-0.4,0.7c-0.1,0.2-0.3,0.4-0.4,0.7l-0.1,0.2c0,0,0,0,0,0.1l-32.5,74.9c-1.4,3.2-0.7,6.9,1.8,9.4
		c1.6,1.6,3.8,2.5,6,2.5c1.1,0,2.3-0.2,3.4-0.7l75-32.7c2-0.9,3.5-2.4,4.4-4.4l32.7-75.1c1.4-3.2,0.7-6.9-1.8-9.4
		C199.1,79.4,195.4,78.6,192.2,80.1z M123.3,135.3l24.8,24.8l-43.9,19.1L123.3,135.3z M160.1,148.1l-24.8-24.8l43.9-19.1
		L160.1,148.1z" />
    </g>
    <path
      display="none"
      d="M141.7,6.4C67.1,6.4,6.4,67.1,6.4,141.7C6.4,216.3,67.1,277,141.7,277S277,216.3,277,141.7
	C277,67.1,216.3,6.4,141.7,6.4z M205.7,124.2h46.9c0.9,5.7,1.4,11.6,1.4,17.5c0,6.1-0.5,12-1.4,17.9h-47c1.6-5.7,2.5-11.7,2.5-17.9
	C208.1,135.7,207.3,129.8,205.7,124.2z M250.2,112.7h-48.8c-6.5-13.3-17.2-24-30.5-30.6V33.3C209.5,43.7,239.9,74.1,250.2,112.7z
	 M141.7,185.1c-23.9,0-43.4-19.5-43.4-43.4c0-23.9,19.5-43.4,43.4-43.4c23.9,0,43.4,19.5,43.4,43.4
	C185.1,165.7,165.7,185.1,141.7,185.1z M159.4,30.8v47c-5.6-1.6-11.6-2.4-17.7-2.4c-6.1,0-12.1,0.9-17.7,2.4v-47
	c5.8-0.9,11.7-1.4,17.7-1.4C147.8,29.4,153.7,29.9,159.4,30.8z M112.5,33.3v48.9c-13.2,6.5-24,17.3-30.5,30.6H33.2
	C43.6,74.1,74,43.7,112.5,33.3z M29.4,141.7c0-6,0.5-11.8,1.4-17.5h46.9c-1.5,5.6-2.4,11.5-2.4,17.5c0,6.2,0.9,12.2,2.5,17.9h-47
	C29.9,153.8,29.4,147.8,29.4,141.7z M33.3,171.1h48.9c6.5,13.1,17.2,23.8,30.3,30.2v48.9C74.1,239.8,43.7,209.5,33.3,171.1z
	 M124,252.6v-47c5.6,1.6,11.6,2.4,17.7,2.4c6.1,0,12.1-0.9,17.7-2.4v47c-5.8,0.9-11.7,1.4-17.7,1.4C135.7,254,129.8,253.6,124,252.6
	z M170.9,250.2v-48.9c13.1-6.5,23.8-17.1,30.3-30.2h48.9C239.7,209.5,209.4,239.8,170.9,250.2z"
    />
    <g display="none">
      <g display="inline">
        <path d="M103.9,264.5L103.9,264.5c-8.6,0-16.8-3.8-22.5-10.5l-24.7-29.7c-8-9.4-24.1-42.3-26.5-54L25,148.4
			c-3-14.7,2.9-31.5,13.7-39.4l46.4-38.3c14-10.3,34-1.2,39.2,14.4l2.7,8.1c4,12.1,4,30.7,0.1,42.4l-8.5,25.2
			c-2.4,7.2-1.4,20.2,2.2,27.2l13.2,25.8c7,13.6,3.8,31.2-7.2,40l-6.2,5C115.9,262.5,110.1,264.5,103.9,264.5L103.9,264.5z
			 M98.5,85.8c-0.6,0-1.1,0.1-1.4,0.4l-46.4,38.3c-4.5,3.3-8.1,12.5-6.6,19.8l5.2,21.8c1.8,8.7,16.6,38.9,22.4,45.7l24.7,29.6
			c1.9,2.2,4.7,3.6,7.5,3.6l0,0c1.2,0,2.9-0.3,4.4-1.5l6.2-5c3.4-2.8,5.1-10.1,2.1-15.9l-13.2-25.8c-6.1-11.9-7.5-30.1-3.3-42.4
			l8.5-25.2c2.6-7.8,2.6-21.8-0.1-30l-2.7-8.1C104.6,88,101.1,85.8,98.5,85.8L98.5,85.8z" />
      </g>
      <path
        display="inline"
        d="M109.7,33.6c2,9.7-3.4,18.9-12,20.7c-8.6,1.7-17.1-4.7-19.1-14.4c-2-9.7,3.4-18.9,12-20.7
		C99.2,17.5,107.8,23.9,109.7,33.6z"
      />
      <path
        display="inline"
        d="M75.6,52.4c1.7,8.4-2.9,16.4-10.4,17.9c-7.4,1.5-14.9-4-16.6-12.4
		C47,49.5,51.6,41.5,59,40C66.5,38.5,73.9,44,75.6,52.4z"
      />
      <path
        display="inline"
        d="M50.5,76.2c1.5,7.4-2.6,14.5-9.2,15.9c-6.6,1.3-13.1-3.6-14.7-11
		c-1.5-7.4,2.6-14.5,9.2-15.9C42.5,63.9,49,68.8,50.5,76.2z"
      />
      <path
        display="inline"
        d="M29,102.2c1.4,6.6-2.3,13-8.2,14.2c-5.9,1.2-11.7-3.2-13.1-9.8c-1.3-6.6,2.3-13,8.2-14.2
		C21.8,91.1,27.7,95.5,29,102.2z"
      />
      <g display="inline">
        <path d="M179.6,264.5c-6.2,0-12-2-16.7-5.8l-6.2-5c-11-8.9-14.2-26.5-7.2-40l13.2-25.8c3.6-7,4.7-20,2.2-27.2
			l-8.5-25.1c-3.9-11.7-3.9-30.3,0.1-42.4l2.7-8.1c3.6-10.9,14.4-18.9,25.8-18.9c4.8,0,9.3,1.4,13,4.1l47.3,39
			c10.3,7.6,16.2,24.4,13.3,38.8l-5.3,22.4c-2.3,11.5-18.5,44.4-26.5,53.8l-24.6,29.5C196.4,260.7,188.2,264.5,179.6,264.5
			L179.6,264.5z M184.9,85.8c-2.6,0-6.1,2.2-7.1,5.4l-2.7,8.1c-2.7,8.2-2.8,22.2-0.2,30l8.5,25.2c4.2,12.3,2.7,30.6-3.3,42.4
			l-13.2,25.8c-3,5.7-1.3,13.1,2.1,15.9l6.2,5c1.5,1.2,3.2,1.4,4.4,1.4c2.8,0,5.6-1.4,7.6-3.6l24.6-29.5c5.8-6.9,20.6-37,22.3-45.4
			l5.3-22.4c1.4-7-2.2-16.1-6.2-19.1l-47.3-39C186,85.9,185.5,85.8,184.9,85.8L184.9,85.8z" />
      </g>
      <path
        display="inline"
        d="M173.8,33.6c-2,9.7,3.4,18.9,11.9,20.7c8.6,1.7,17.1-4.7,19.1-14.4
		c2-9.7-3.4-18.9-12-20.7C184.3,17.5,175.7,23.9,173.8,33.6z"
      />
      <path
        display="inline"
        d="M207.9,52.4c-1.7,8.4,2.9,16.4,10.4,17.9c7.4,1.5,14.9-4,16.6-12.4
		c1.7-8.4-2.9-16.4-10.4-17.9C217,38.5,209.6,44,207.9,52.4z"
      />
      <path
        display="inline"
        d="M232.9,76.2c-1.5,7.4,2.6,14.5,9.2,15.9c6.6,1.3,13.2-3.6,14.7-11
		c1.5-7.4-2.6-14.5-9.2-15.9C241,63.9,234.4,68.8,232.9,76.2z"
      />
      <path
        display="inline"
        d="M254.4,102.2c-1.3,6.6,2.3,13,8.2,14.2c5.9,1.2,11.7-3.2,13.1-9.8
		c1.3-6.6-2.3-13-8.2-14.2C261.7,91.1,255.8,95.5,254.4,102.2z"
      />
    </g>
    <path
      display="none"
      d="M274.4,126.2c0-20.5-16.6-37.1-37.4-37.1l-4.6,0c-23.7,0-37.8-2.4-43.1-4.4
	c0.1-2.1,0.2-4.4,0.4-6.6c0.2-1.8,0.5-3.6,0.8-5.4c0.4-3.1,0.9-6,1.1-8.7c1.8-21.8-2.6-40.2-11.9-50.3c-4.6-5-10.3-7.7-16.1-7.7
	c-1.7,0-16.5,0.3-24.2,8.8c-3.3,3.7-4.8,8.5-4.3,13.4c0.1,0.8,2.2,20.4-2.4,36.8c-6.4,11.1-21.5,28.6-34.7,41.7
	c-1-2-2.6-3.7-4.6-4.8c-2.6-1.4-5.7-1.8-8.6-0.9l-67.5,19.9c-5.9,1.8-9.3,8-7.6,13.9l39.7,134.7c1.4,4.9,5.9,8,10.8,8
	c1.1,0,2.1-0.1,3.2-0.4l67.5-19.9c2.9-0.8,5.3-2.8,6.7-5.4c1.4-2.6,1.8-5.7,0.9-8.6l-7.2-24.5c5.6-0.3,12.9-0.2,21.9,0.6l17.6,1.5
	c11.7,1,22,1.9,28.7,2.7c2.7,0.3,5.8,0.6,9,0.6c16.5,0,27.9-6,32-17c0.3-0.8,0.5-1.6,0.8-2.4c9.4-5.6,15.5-15.4,16.1-26.2
	c0-0.2,0-0.4,0-0.5c6.2-5.7,10-13.6,10.5-22.1c0.2-2.6,0-5.3-0.5-7.8C271.9,141.7,274.4,134.2,274.4,126.2z M67.6,252.4L34.4,139.8
	l-0.2-0.6l45.9-13.6l0.3,1c-0.1,1.3,0.1,2.6,0.4,3.8l24.2,82.1c0.4,1.2,1,2.4,1.7,3.4l6.7,22.9L67.6,252.4z M247.1,137
	c-3.6,3.2-4.7,8.4-2.7,12.8c0.7,1.6,1,3.2,0.9,4.9c-0.2,3.4-2.1,6.6-5.2,8.4c-4.1,2.4-6.2,7-5.4,11.7c0.2,0.9,0.2,1.6,0.2,2.4
	c-0.2,4.2-3.1,7.9-7.3,9.4c-4.1,1.4-6.9,5.1-7.4,9.3c-0.1,1.2-0.4,2.4-0.8,3.5c-0.3,0.5-3.4,2.4-11,2.4c-2.2,0-4.4-0.2-6.2-0.4
	c-6.9-0.9-17.5-1.8-29.7-2.8l-17.5-1.5c-6.4-0.6-12.4-0.9-17.7-0.9c-4.5,0-8.8,0.2-12.7,0.6l-19.4-66c16.6-14.9,39.2-40.2,47.7-55.9
	c0.4-0.7,0.6-1.3,0.9-2c5.2-16.7,4.5-35.4,3.9-43.4c1.5-0.4,3.5-0.8,5-0.9c2.7,2.1,8.2,12.7,6.5,33.7c-0.2,2.3-0.5,4.7-0.9,7.3
	c-0.3,1.9-0.6,3.9-0.9,6.4c-0.4,4.5-0.5,8.5-0.6,12c-0.1,4.3,1.6,8.5,4.8,11.8c2.9,3,11.7,12,60.9,12c3,0,4.9,0,4.9,0
	c8.1,0,14.6,6.6,14.6,14.7C252,130.3,250.2,134.1,247.1,137z"
    />
    <g display="none">
      <path
        display="inline"
        d="M141.7,158.3c30.5,0,55.3-24.8,55.3-55.3c0-30.5-24.8-55.3-55.3-55.3S86.4,72.5,86.4,103
		C86.4,133.5,111.2,158.3,141.7,158.3z M141.7,58.8c24.4,0,44.2,19.8,44.2,44.2c0,24.4-19.8,44.2-44.2,44.2S97.5,127.4,97.5,103
		C97.5,78.6,117.4,58.8,141.7,58.8z"
      />
      <path
        display="inline"
        d="M256.2,228l-37.6-67.7c12-16,19-35.8,19-57.3c0-52.9-43-96-95.9-96c-52.9,0-96,43-96,96
		c0,21.5,7.1,41.3,19.1,57.3L27.2,228c-1.9,3.4-1.9,7.5,0.1,10.9c1.9,3.4,5.5,5.5,9.4,5.6l31.4,0.7l17.2,26.2c2.1,3.1,5.5,5,9.3,5
		c0.1,0,0.3,0,0.4,0c3.9-0.1,7.4-2.3,9.3-5.7l37.5-67.6l37.5,67.6c1.9,3.4,5.4,5.6,9.3,5.7c0.1,0,0.3,0,0.4,0c3.7,0,7.2-1.9,9.3-5
		l17.2-26.2l31.4-0.7c3.9-0.1,7.4-2.2,9.4-5.6C258.1,235.5,258.1,231.4,256.2,228z M141.7,29.2c40.7,0,73.8,33.1,73.8,73.8
		c0,40.7-33.1,73.8-73.8,73.8c-40.7,0-73.8-33.1-73.8-73.8C67.9,62.3,101,29.2,141.7,29.2z M93.7,243.9l-10.3-15.7c-2-3-5.4-4.9-9-5
		l-18.8-0.4l25.3-45.6c11.2,9.2,24.6,16,39.2,19.4L93.7,243.9z M209.1,223.1c-3.7,0.1-7,2-9,5l-10.3,15.7l-26.3-47.4
		c14.6-3.4,28-10.1,39.2-19.4l25.3,45.6L209.1,223.1z"
      />
    </g>
    <g display="none">
      <path
        display="inline"
        d="M248.1,131.7h1.2V53.5c0-11.9-9.7-21.6-21.6-21.6H30.9C19,31.9,9.4,41.6,9.4,53.5v121.3
		c0,11.9,9.7,21.6,21.6,21.6h24.3V226c0,4.1,2.4,7.9,6.1,9.7c1.5,0.7,3.1,1.1,4.7,1.1c2.4,0,4.7-0.8,6.7-2.3l48.2-38.1h20.3
		c5.6,31.3,33,55.2,65.9,55.2c36.9,0,67-30,67-67C274.1,163.1,263.9,144,248.1,131.7z M117.2,174.8c-2.4,0-4.8,0.8-6.7,2.3
		l-33.7,26.6v-18.2c0-6-4.8-10.8-10.8-10.8H30.9V53.5h196.8v67.4c-6.5-2.1-13.4-3.3-20.6-3.3c-10.6,0-20.6,2.5-29.5,6.9
		c-0.1,0-0.1,0-0.2,0H71.4c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4h90.6c-11.1,10.2-18.7,24-21,39.5H117.2z M207.1,240.8
		c-31,0-56.2-25.2-56.2-56.2c0-31,25.2-56.2,56.2-56.2c31,0,56.2,25.2,56.2,56.2C263.3,215.6,238.1,240.8,207.1,240.8z"
      />
      <path
        display="inline"
        d="M235.8,155.9c-4.2-4.2-11-4.2-15.3,0l-13.4,13.4l-13.4-13.4c-4.2-4.2-11-4.2-15.3,0
		c-4.2,4.2-4.2,11,0,15.3l13.5,13.5L178.4,198c-4.2,4.2-4.2,11,0,15.3c2.1,2.1,4.9,3.2,7.6,3.2c2.8,0,5.5-1.1,7.6-3.2l13.4-13.4
		l13.4,13.4c2.1,2.1,4.9,3.2,7.6,3.2c2.8,0,5.5-1.1,7.6-3.2c4.2-4.2,4.2-11,0-15.3l-13.5-13.5l13.5-13.5
		C240.1,166.9,240.1,160.1,235.8,155.9z"
      />
      <path
        display="inline"
        d="M71.4,102h121.3c3,0,5.4-2.4,5.4-5.4c0-3-2.4-5.4-5.4-5.4H71.4c-3,0-5.4,2.4-5.4,5.4
		C66,99.6,68.4,102,71.4,102z"
      />
    </g>
    <g display="none">
      <path
        display="inline"
        d="M265,41.7h-34v-8c0-6.6-5.4-12-12-12c-6.6,0-12,5.4-12,12v8H77.8v-8c0-6.6-5.4-12-12-12
		c-6.6,0-12,5.4-12,12v8H18.5c-6.6,0-12,5.4-12,12v196.1c0,6.6,5.4,12,12,12H265c6.6,0,12-5.4,12-12V53.7
		C277,47,271.6,41.7,265,41.7z M53.8,65.7v8c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12v-8H207v8c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12
		v-8h22v46.9H30.5V65.7H53.8z M30.5,237.8V124.6H253v113.2H30.5z"
      />
      <rect x="51.3" y="148.9" display="inline" width="23.3" height="23.3" />
      <rect x="91.7" y="148.9" display="inline" width="23.3" height="23.3" />
      <rect x="132" y="148.9" display="inline" width="23.3" height="23.3" />
      <rect x="172.3" y="148.9" display="inline" width="23.3" height="23.3" />
      <rect x="212.7" y="148.9" display="inline" width="23.3" height="23.3" />
      <rect x="51.3" y="186.4" display="inline" width="23.3" height="23.3" />
      <rect x="91.7" y="186.4" display="inline" width="23.3" height="23.3" />
      <rect x="132" y="186.4" display="inline" width="23.3" height="23.3" />
      <rect x="172.3" y="186.4" display="inline" width="23.3" height="23.3" />
      <rect x="212.7" y="186.4" display="inline" width="23.3" height="23.3" />
    </g>
    <path
      display="none"
      d="M267.7,117.6l-26.9-39.5c-1.7-2.4-4.2-4.1-7.1-4.6c-2.9-0.5-5.8,0.1-8.3,1.7l-7.4,5V29.9
	c0-6.1-4.9-11-11-11h-33.9c-4.2-6.6-11.5-11-19.9-11H78.7c-8.4,0-15.7,4.4-19.9,11H24.8c-6.1,0-11,4.9-11,11v234.6
	c0,6.1,4.9,11,11,11H207c6.1,0,11-4.9,11-11v-99.7l46.8-31.9c2.4-1.6,4.1-4.2,4.6-7.1C270,123,269.4,120,267.7,117.6z M217.2,116.4
	l-93.8,64c-2.5,1.7-3.2,5.2-1.4,7.7c1.1,1.6,2.8,2.4,4.6,2.4c1.1,0,2.2-0.3,3.1-1l93.8-64l4.1,6.1l-96.9,66.1l-9.8-1.3
	c-0.5-2.1-1.4-4.2-2.7-6c-1.2-1.8-2.7-3.3-4.4-4.5l2.4-9.5l96.9-66.1L217.2,116.4z M196,253.5H35.9V41h21.4
	c3.7,8.1,11.9,13.8,21.4,13.8h74.5c9.5,0,17.7-5.7,21.4-13.8H196v54.3l-95.8,65.3c-2.2,1.5-3.8,3.8-4.5,6.4L87,202
	c-0.8,3.1-0.2,6.3,1.6,8.9c1.8,2.6,4.6,4.3,7.7,4.7l35.7,4.6c0.5,0.1,0.9,0.1,1.4,0.1c2.2,0,4.4-0.7,6.2-1.9l56.4-38.5V253.5z
	 M236.7,125.4l-14.5-21.3l6.6-4.5l14.5,21.3L236.7,125.4z"
    />
    <path
      display="none"
      d="M270.2,61.7l-25.7-28.2c-2.1-2.3-5.1-3.6-8.2-3.6l-90.7-0.2l0-8.8c0-6.2-5-11.2-11.1-11.2h0
	c-6.1,0-11.1,5-11.2,11.1l0,8.8l-58.8-0.2c0,0,0,0,0,0c-6.1,0-11.1,5-11.2,11.1l-0.2,56.3c0,3,1.2,5.8,3.2,7.9
	c2.1,2.1,4.9,3.3,7.9,3.3l58.8,0.2l0,10.7l-75.8-0.2h0c-3.1,0-6.1,1.3-8.2,3.6l-25.8,28.1c-3.9,4.2-3.9,10.8,0,15.1l25.6,28.2
	c2.1,2.3,5.1,3.6,8.2,3.6l75.8,0.2l-0.2,65.3c0,6.2,5,11.2,11.1,11.2h0c6.1,0,11.2-5,11.2-11.1l0.2-65.3l73.7,0.2h0
	c3,0,5.8-1.2,7.9-3.2c2.1-2.1,3.3-4.9,3.3-7.9l0.2-56.3c0-6.2-5-11.2-11.1-11.2l-73.7-0.2l0-10.7l90.7,0.2h0c3.1,0,6.1-1.3,8.2-3.6
	l25.8-28.1C274.1,72.5,274.1,66,270.2,61.7z M207.8,175.3l-155.7-0.4l-15.5-17l15.6-16.9l155.7,0.4L207.8,175.3z M231.3,86.1
	L75.6,85.7l0.1-33.9l155.7,0.4l15.5,17L231.3,86.1z"
    />
    <path
      display="none"
      d="M199.5,23.9l-1.5,0c-22.2,0.3-42.6,9.9-57,26.3c-14.7-15.8-35.1-24.9-57.6-24.9h0
	c-19.9,0.1-38.8,8.2-53.2,22.8C14.4,64.2,5.5,86.9,5.8,110.4c0.1,8.9,1.5,17.5,3.9,24.6c4.9,21.7,30.9,50.2,81.6,89.7
	c13.2,10.2,33.2,24.1,41.7,30l3.6,2.5c0.5,0.4,1,0.7,1.5,1c1.7,1,3.6,1.4,5.5,1.4c2.1,0,4.3-0.6,6.2-1.8
	c11.4-7.2,26.7-18.7,45.5-34.2c48.9-40.1,74.8-70.1,78.9-90.9c2.4-8.2,3.6-16.9,3.5-25.7C277,61.2,242,23.9,199.5,23.9z
	 M251.8,127.2c-1.8,9.1-13.5,31.3-71.2,78.6c-14.5,11.9-27.1,21.6-36.8,28.4c-9.3-6.5-26.7-18.7-38.4-27.7
	c-59.1-46-71.3-67.7-73.6-77.6c-1.9-5.9-3-12.3-3-18.8c-0.2-17.4,6.3-34.2,17.8-45.9c10.1-10.2,23.1-15.9,37.6-16
	c19.3,0,36.9,10.2,47.2,27.2c2.1,3.5,6.2,5.5,10,5.6c4.1-0.1,7.8-2.3,9.8-5.8c10-17.5,27.6-28.1,47.1-28.3c0,0,1.1,0,1.2,0
	c30,0,54.7,27.1,55.1,60.4C254.7,113.8,253.8,120.2,251.8,127.2z"
    />
    <g display="none">
      <path
        display="inline"
        d="M141.8,46.8c-6.4,0-11.5,5.2-11.5,11.5v78.6l-31.5,31.5c-4.5,4.5-4.5,11.8,0,16.3
		c2.3,2.3,5.2,3.4,8.2,3.4c3,0,5.9-1.1,8.2-3.4l33.5-33.5c0.2-0.2,0.4-0.4,0.6-0.7c2.5-2.1,4.2-5.3,4.2-8.9V58.4
		C153.3,52,148.1,46.8,141.8,46.8z"
      />
      <path
        display="inline"
        d="M276.5,141.7C276.5,141.7,276.5,141.7,276.5,141.7C276.4,67.4,216,7,141.8,7
		C67.5,7,7,67.4,7,141.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C7,216,67.5,276.5,141.8,276.5C216,276.5,276.5,216,276.5,141.7
		C276.5,141.7,276.5,141.7,276.5,141.7C276.5,141.7,276.5,141.7,276.5,141.7z M241.2,192.4l-5.5-3.2c-2.8-1.6-6.3-0.6-7.9,2.1
		c-1.6,2.8-0.6,6.3,2.1,7.9l5.5,3.2c-8.5,13.1-19.8,24.4-32.9,32.9l-3.2-5.5c-1.6-2.8-5.2-3.7-7.9-2.1c-2.8,1.6-3.7,5.1-2.1,7.9
		l3.2,5.5c-12.2,6.3-25.8,10.4-40.1,11.7c-1.8-4.1-5.8-7-10.6-7c-4.8,0-8.8,2.9-10.6,7c-14.3-1.4-27.9-5.4-40.1-11.7l3.2-5.6
		c1.6-2.8,0.6-6.3-2.1-7.9c-2.8-1.6-6.3-0.6-7.9,2.1l-3.2,5.5c-13.1-8.5-24.4-19.8-32.9-32.9l5.5-3.2c2.8-1.6,3.7-5.1,2.2-7.9
		c-1.6-2.8-5.1-3.7-7.9-2.2l-5.6,3.2C36,180.2,32,166.7,30.6,152.3c4.1-1.8,7-5.9,7-10.6c0-4.8-2.9-8.8-7-10.6
		C32,116.8,36,103.2,42.3,91l5.6,3.2c0.9,0.5,1.9,0.8,2.9,0.8c2,0,3.9-1,5-2.9c1.6-2.8,0.6-6.3-2.1-7.9L48.1,81
		C56.7,67.9,67.9,56.6,81,48.1l3.2,5.5c1.1,1.9,3,2.9,5,2.9c1,0,2-0.2,2.9-0.8c2.8-1.6,3.7-5.1,2.1-7.9L91,42.3
		c12.2-6.3,25.8-10.3,40.1-11.7c1.8,4.1,5.8,7,10.6,7c4.8,0,8.8-2.9,10.6-7c14.3,1.4,27.9,5.4,40.1,11.7l-3.2,5.6
		c-1.6,2.8-0.6,6.3,2.1,7.9c0.9,0.5,1.9,0.8,2.9,0.8c2,0,3.9-1,5-2.9l3.2-5.5c13.1,8.5,24.4,19.8,32.9,32.9l-5.5,3.2
		c-2.8,1.6-3.7,5.1-2.1,7.9c1.1,1.9,3,2.9,5,2.9c1,0,2-0.2,2.9-0.8l5.5-3.2c6.3,12.2,10.3,25.8,11.7,40.1c-4.1,1.8-7,5.9-7,10.6
		c0,4.8,2.9,8.8,7,10.6C251.5,166.7,247.4,180.2,241.2,192.4z"
      />
    </g>
    <g display="none">
      <path
        display="inline"
        d="M258.2,107.1l-19.3-0.5l-4-9.1l13.6-13.6c3.7-3.7,5.8-8.7,5.8-14c0-5.3-2.1-10.2-5.7-13.9
		l-21.1-21.1c-3.7-3.7-8.7-5.7-13.9-5.7c-5.3,0-10.2,2-13.9,5.8l-14,13.2l-9.2-3.6V25.3c0-10.9-8.8-19.7-19.7-19.7h-29.8
		c-10.9,0-19.7,8.8-19.7,19.7l-0.6,19.3l-9.1,4L83.9,34.9c-7.4-7.4-20.5-7.4-27.9,0L35,56c-3.8,3.7-5.8,8.7-5.8,14
		c0,5.3,2.1,10.2,5.8,13.9l13.2,14l-3.6,9.2H25.3c-10.9,0-19.7,8.8-19.7,19.7v29.8c0,10.9,8.8,19.7,19.7,19.7l19.3,0.5l4,9.1
		L35,199.6c-3.8,3.7-5.8,8.7-5.8,14c0,5.3,2.1,10.2,5.8,13.9L56,248.5c7.4,7.4,20.4,7.4,27.9,0l14-13.2l9.2,3.6v19.3
		c0,10.9,8.8,19.7,19.7,19.7h29.8c10.9,0,19.7-8.8,19.7-19.7l0.5-19.3l9.1-4l13.7,13.7c7.4,7.4,20.3,7.4,27.9,0l21-21
		c3.7-3.7,5.8-8.7,5.8-14c0-5.3-2.1-10.2-5.8-13.9l-13.2-14l3.6-9.3h19.3c10.9,0,19.7-8.8,19.7-19.7v-29.8
		C277.9,116,269.1,107.1,258.2,107.1z M254.7,153.2h-15.8c-9.4,0-18.7,6.7-21.4,14.9l-3.3,8c-4.2,8.4-2.4,19.7,4.3,26.4l11.2,11.2
		l-16.2,16.2l-11.2-11.2c-4.2-4.2-10.2-6.6-16.5-6.6c-3.5,0-6.9,0.8-9.2,1.9l-8,3.3c-8.9,3-15.6,12.3-15.6,21.7v15.8h-22.9v-15.8
		c0-9.5-6.6-18.7-14.9-21.4l-7.9-3.2c-8.3-4.2-19.9-2.2-26.4,4.3l-11.2,11.2l-16.2-16.2L65,202.4c6.6-6.6,8.4-18,4.6-25.6l-3.3-8
		c-3-8.9-12.3-15.6-21.7-15.6H28.8v-22.9h15.8c9.4,0,18.7-6.7,21.4-14.9l3.2-7.9c4.2-8.4,2.4-19.7-4.3-26.4L53.8,69.9l16.2-16.2
		l11.2,11.2c4.1,4.2,10.2,6.6,16.5,6.6c3.5,0,7-0.8,9.2-1.9l7.9-3.3c8.9-3,15.6-12.3,15.6-21.7V28.8h22.9v15.8
		c0,9.4,6.7,18.7,14.8,21.4l7.9,3.3c8.3,4.1,19.9,2.2,26.4-4.3l11.2-11.2l16.2,16.2l-11.2,11.2c-6.6,6.6-8.4,18-4.6,25.6l3.3,7.9
		c3,8.9,12.3,15.7,21.7,15.7h15.8V153.2z"
      />
      <path
        display="inline"
        d="M141.7,90.9c-28,0-50.8,22.8-50.8,50.9c0,28,22.8,50.9,50.8,50.9
		c28,0,50.9-22.8,50.9-50.9C192.6,113.7,169.8,90.9,141.7,90.9z M141.7,169.4c-15.3,0-27.7-12.4-27.7-27.7
		c0-15.3,12.4-27.7,27.7-27.7c15.3,0,27.7,12.4,27.7,27.7C169.4,157,157,169.4,141.7,169.4z"
      />
    </g>
    <path
      display="none"
      d="M249.7,43.1H33.8c-15.5,0-28,12.6-28,28v141.2c0,15.5,12.6,28,28,28h215.8
	c15.4,0,28-12.6,28-28V71.1C277.7,55.7,265.1,43.1,249.7,43.1z M249.7,216.6H33.8c-1.2,0-2.3-0.5-3-1.3l73.6-65.6l33.4,29.8
	c1.1,1,2.5,1.5,4,1.5c1.4,0,2.8-0.5,4-1.5l33.4-29.8l73.6,65.6C251.9,216.1,250.8,216.6,249.7,216.6z M141.7,167.1l-111-98.9
	c0.8-0.8,1.9-1.3,3-1.3h215.8c1.2,0,2.3,0.5,3,1.3L141.7,167.1z M29.6,83l65.8,58.7l-65.8,58.7V83z M188.1,141.7L253.9,83v117.4
	L188.1,141.7z"
    />
  </SvgIcon>
)

export default ContactIcon



// WEBPACK FOOTER //
// ./src/assets/svg/ContactIcon.js